import React from "react";
import { Select } from "antd";
const { Option } = Select;

interface DataField {
  traitName: string;
  traitLabel: string;
  traitDataType: string;
}

// Expanded fields array with more data types
const fields: DataField[] = [
  // Integer Number fields
  {
    traitName: "Customer.Age",
    traitLabel: "Age",
    traitDataType: "Integer Number",
  },
  {
    traitName: "Order.Quantity",
    traitLabel: "Order Quantity",
    traitDataType: "Integer Number",
  },
  // Floating Point Number fields
  {
    traitName: "Customer.TotalSpend",
    traitLabel: "Total Spend",
    traitDataType: "Floating Point Number",
  },
  {
    traitName: "Order.Amount",
    traitLabel: "Order Amount",
    traitDataType: "Floating Point Number",
  },
  // Character String fields
  {
    traitName: "Customer.FirstName",
    traitLabel: "First Name",
    traitDataType: "Character String",
  },
  {
    traitName: "Customer.LastName",
    traitLabel: "Last Name",
    traitDataType: "Character String",
  },
  {
    traitName: "Customer.Email",
    traitLabel: "Email",
    traitDataType: "Character String",
  },
  // Instance Object (Date/Time) fields
  {
    traitName: "Customer.DateOfBirth",
    traitLabel: "Date of Birth",
    traitDataType: "Instance Object",
  },
  {
    traitName: "Order.CreatedDate",
    traitLabel: "Order Date",
    traitDataType: "Instance Object",
  },
  // Logical Truth fields
  {
    traitName: "Customer.IsActive",
    traitLabel: "Is Active",
    traitDataType: "Logical Truth",
  },
  {
    traitName: "Order.IsCompleted",
    traitLabel: "Is Completed",
    traitDataType: "Logical Truth",
  },
  // Binary Bit fields
  {
    traitName: "Customer.HasSubscription",
    traitLabel: "Has Subscription",
    traitDataType: "Binary Bit",
  },
  // Text Object fields
  {
    traitName: "Customer.Notes",
    traitLabel: "Customer Notes",
    traitDataType: "Text Object",
  },
  // Interval Object fields
  {
    traitName: "Order.DeliveryTime",
    traitLabel: "Delivery Time",
    traitDataType: "Interval Object",
  }
];

interface DataFieldPathExpressionProps {
  value: string;
  onChange: (value: string) => void;
  dataType?: string;
  onDataTypeChange?: (value: string) => void;
}

export const DataFieldPathExpression: React.FC<DataFieldPathExpressionProps> = ({ 
  value, 
  onChange,
  dataType,
  onDataTypeChange
}) => {
  // Filter fields based on dataType only if it's provided
  const filteredFields = dataType 
    ? fields.filter(field => field.traitDataType === dataType)
    : fields;  // Show all fields if no dataType

  const handleChange = (selectedValue: string) => {
    onChange(selectedValue);
    // Update dataType based on selected field
    const selectedField = fields.find(field => field.traitName === selectedValue);
    if (selectedField && onDataTypeChange) {
      onDataTypeChange(selectedField.traitDataType);
    }
  };

  return (
    <Select
      value={value}
      onChange={handleChange}
      showSearch
      optionFilterProp="children"
      placeholder="Select a field"
      style={{ width: '200px' }}
    >
      {filteredFields.map((field) => (
        <Option key={field.traitName} value={field.traitName}>
          {`${field.traitLabel} (${field.traitDataType})`}
        </Option>
      ))}
    </Select>
  );
}; 